import { Fragment } from "react";

const URL_PATTERN = /(https?:\/\/[^\s<]+)/gi;
const TRAILING_PUNCTUATION = /[),.;:!?\]}]+$/;

export function AutoLinkText({ text }: { text: string }) {
  return text.split(URL_PATTERN).map((part, index) => {
    if (!/^https?:\/\//i.test(part)) {
      return <Fragment key={`${index}-${part}`}>{part}</Fragment>;
    }

    const trailing = part.match(TRAILING_PUNCTUATION)?.[0] ?? "";
    const href = trailing ? part.slice(0, -trailing.length) : part;

    return (
      <Fragment key={`${index}-${part}`}>
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="break-all font-medium underline decoration-current/45 underline-offset-4 transition hover:decoration-current"
        >
          {href}
        </a>
        {trailing}
      </Fragment>
    );
  });
}
